import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

export const Content = styled.div`
  display: flex;
  align-items: center;
  gap: ${themeGet('space.3')}px;

  > svg {
    width: 30px;
    height: 30px;
    color: ${themeGet('colors.primary.main')};
  }

  @media screen and (min-width: ${themeGet('breakpoints.1')}) {
    > svg {
      width: 35px;
      height: 35px;
    }
  }
`
